/**
 * BY VALENTI — Gift / Upsell Add-to-Cart
 * File: assets/bv-cart-gift-manu.js
 *
 * Uses Shopify's standard cart action so Atelier
 * handles its own cart drawer refresh.
 */

(function () {
  'use strict';

  var isAdding = false;

  async function onGiftClick(event) {
    event.preventDefault();
    event.stopPropagation();

    var btn = event.currentTarget;

    if (!btn || btn.disabled || isAdding) {
      return;
    }

    var variantId =
      btn.getAttribute('data-variant-id');

    var qualified =
      btn.getAttribute('data-free-if-qualified') === 'true';

    var loadingLabel =
      btn.getAttribute('data-loading-label') || '...';

    var originalLabel =
      btn.textContent.trim();

    if (!variantId) {
      console.error('[BV Gift] Missing variant ID.');
      return;
    }

    if (
      !window.Shopify ||
      !Shopify.actions ||
      !Shopify.actions.updateCart
    ) {
      console.error(
        '[BV Gift] Shopify.actions.updateCart is unavailable.'
      );
      return;
    }

    isAdding = true;

    btn.disabled = true;
    btn.textContent = loadingLabel;

    /*
     * Shopify standard cart actions require
     * the Storefront API ProductVariant GID.
     */
    var merchandiseId =
      'gid://shopify/ProductVariant/' + variantId;

    var line = {
      merchandiseId: merchandiseId,
      quantity: 1
    };

    /*
     * Qualified complimentary gift only.
     *
     * Storefront CartLine attributes are custom
     * key/value data attached to that specific line.
     */
    if (qualified) {
      line.attributes = [
        {
          key: 'Free Gift',
          value: 'yes'
        }
      ];
    }

    try {
      /*
       * IMPORTANT:
       *
       * Do NOT manually call /cart/add.js.
       * Do NOT manually refresh the drawer.
       *
       * Atelier handles the mutation and emits
       * its own cart update event.
       */
      var result =
        await Shopify.actions.updateCart(
          {
            lines: [line]
          },
          {
            event: {
              context: 'cart',
              detail: {
                source: 'bv-gift-widget'
              }
            }
          }
        );

      /*
       * Shopify can return validation errors
       * without rejecting the Promise.
       */
      if (
        result.userErrors &&
        result.userErrors.length
      ) {
        throw new Error(
          result.userErrors[0].message ||
          'Shopify rejected the cart addition.'
        );
      }

      /*
       * Do nothing else here.
       *
       * Atelier receives shopify:cart:lines-update
       * and refreshes its own drawer.
       */

      isAdding = false;

    } catch (error) {
      console.error(
        '[BV Gift] Add-to-cart failed:',
        error
      );

      btn.disabled = false;
      btn.textContent = originalLabel;

      isAdding = false;
    }
  }

  function bindButtons() {
    var buttons =
      document.querySelectorAll(
        '[data-bv-add-gift]'
      );

    buttons.forEach(function (btn) {
      if (
        btn.dataset.bvGiftBound === 'true'
      ) {
        return;
      }

      btn.dataset.bvGiftBound = 'true';

      btn.addEventListener(
        'click',
        onGiftClick
      );
    });
  }

  function init() {
    bindButtons();

    /*
     * Atelier replaces cart markup when the
     * cart changes, so bind newly rendered buttons.
     */
    var observer =
      new MutationObserver(function () {
        bindButtons();
      });

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();